import type { SVGProps } from 'react';

const SvgExit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M19.14 5.55a.75.75 0 0 0-.8-.09.74.74 0 0 0-.43.67v5.1H1.68v-8a1.25 1.25 0 0 1 1.25-1.3h9.54a1.25 1.25 0 0 1 1.25 1.25V9h1.5V3.18A2.75 2.75 0 0 0 12.47.43H2.93A2.75 2.75 0 0 0 .18 3.18v25.43a2.75 2.75 0 0 0 2.75 2.75h9.54a2.75 2.75 0 0 0 2.75-2.75v-4.93h-1.5v4.93a1.25 1.25 0 0 1-1.25 1.25H2.93a1.25 1.25 0 0 1-1.25-1.25V21h16.23v4.66a.75.75 0 0 0 .42.67.76.76 0 0 0 .33.08.74.74 0 0 0 .45-.15l12.41-9.37a.75.75 0 0 0 0-1.18Zm.27 18.6v-3.9a.75.75 0 0 0-.75-.75h-17v-6.77h17a.74.74 0 0 0 .75-.75V7.72l10.45 8.54Z"
      data-name="exit"
    />
  </svg>
);

export default SvgExit;
